import React from 'react';
import { ChartBar } from '@phosphor-icons/react';

const Reports = () => {
  return (
    <div data-testid="reports-page">
      <div className="mb-6">
        <h1 className="text-4xl font-bold text-[#1A1A1A]" style={{ fontFamily: 'Work Sans, sans-serif' }}>
          Reports & Analytics
        </h1>
        <p className="text-[#6B7280] mt-2">View detailed reports and analytics</p>
      </div>

      <div className="bg-white rounded-lg border border-[#E5E7EB] p-12 text-center">
        <ChartBar size={64} className="mx-auto text-[#6B7280] mb-4" weight="duotone" />
        <h3 className="text-xl font-semibold text-[#1A1A1A] mb-2">Advanced Reports Coming Soon</h3>
        <p className="text-[#6B7280]">
          Detailed analytics, profit reports, and loan performance metrics will be available in the next update.
        </p>
      </div>
    </div>
  );
};

export default Reports;
